const colors = ['#7022F8', '#0388D1', '#08CAB0', '#FF612F', '#FF368A'];

export interface Options {
  size?: number;
  color?: string;
}

export default function genAvatar(fingerprint: string, options?: Options) {
  const { size, color } = Object.assign({ size: 150 }, options);

  fingerprint = fingerprint || 'A';

  const half = size / 2;

  const canvasDom = document.createElement('canvas');
  canvasDom.width = size!;
  canvasDom.height = size!;
  const ctx = canvasDom.getContext('2d')!;

  ctx.beginPath();

  // Background
  ctx.arc(half, half, half, 0, Math.PI * 2, true);
  ctx.fillStyle = color || getColor(fingerprint);
  ctx.fill();

  // Font
  ctx.font = `bold ${half}px/2 Manrope`;
  ctx.fillStyle = '#fff';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'alphabetic';
  const text = fingerprint[0].toUpperCase();
  const measureText = ctx.measureText(text);
  const baseLineToTextTopHeight = measureText.actualBoundingBoxAscent;
  ctx.fillText(fingerprint[0].toUpperCase(), half, half + baseLineToTextTopHeight / 2);

  return canvasDom.toDataURL('image/png', 1);
}

function getColor(fingerprint: string) {
  const code = Array.from(fingerprint).reduce((acc, cur) => acc + cur.charCodeAt(0), 0);
  return colors[code % colors.length];
}

export function getAvatar(
  avatar: string | undefined,
  name: string | undefined,
  options?: Options
) {
  if (avatar) {
    return avatar[0] === '#'
      ? genAvatar(name || '', {
          color: avatar,
          ...options,
        })
      : avatar;
  } else {
    return genAvatar(name || '', options);
  }
}
